'use client';

import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import AppImage from './ui/AppImage';

function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name: string, value: string, days: number) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

export default function AgeVerification() {
  const router = useRouter();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const verified = getCookie('age_verified');
    if (!verified) {
      setVisible(true);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const handleYes = () => {
    setCookie('age_verified', 'true', 30);
    document.body.style.overflow = '';
    setVisible(false);
  };

  const handleNo = () => {
    document.body.style.overflow = '';
    router.push('/underage');
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}
      aria-modal="true"
      role="dialog"
      aria-labelledby="age-verify-heading"
    >
      <div className="bg-white rounded-2xl shadow-2xl px-8 py-10 mx-4 max-w-sm w-full flex flex-col items-center text-center">
        {/* Logo */}
        <div className="mb-6">
          <AppImage
            src="/assets/images/Untitled-1772518473290.jpeg"
            alt="Kratapillar logo"
            width={80}
            height={80}
            className="rounded-full object-cover"
          />
        </div>

        {/* Heading */}
        <h1
          id="age-verify-heading"
          className="text-2xl font-bold mb-6 text-gray-900"
          style={{ fontFamily: "'Fraunces', serif" }}
        >
          Are you 21 or older?
        </h1>

        {/* Buttons */}
        <div className="flex flex-col gap-3 w-full mb-5">
          <button
            onClick={handleYes}
            className="w-full py-3 px-6 rounded-lg text-white font-semibold text-base transition-opacity hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2"
            style={{ backgroundColor: '#3F5A45', fontFamily: "'Inter', sans-serif" }}
          >
            Yes, I&apos;m 21+
          </button>
          <button
            onClick={handleNo}
            className="w-full py-3 px-6 rounded-lg text-gray-600 font-semibold text-base border border-gray-400 bg-transparent transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            No
          </button>
        </div>

        {/* Disclaimer */}
        <p
          className="text-xs text-gray-500 leading-relaxed"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          You must be 21 years of age or older to enter this site.
        </p>
      </div>
    </div>
  );
}
